module.exports = __webpack_public_path__ + "static/media/spinner.4a77fa96.gif";